import React from "react";
import {
    Search,
    RefreshCw,
    User
} from "lucide-react";

export default function ConversationList({

    loading,

    search,

    setSearch,

    conversations,

    selectedConversation,

    onSelect,

    refreshChats

}) {

    return (

        <div className="conversation-sidebar">

            {/* Header */}

            <div className="sidebar-header">

                <h2>

                    WhatsApp

                </h2>

                <button

                    className="refresh-btn"

                    onClick={refreshChats}

                >

                    <RefreshCw size={18} />

                </button>

            </div>

            {/* Search */}

            <div className="search-box">

                <Search size={18} />

                <input

                    type="text"

                    placeholder="Search"

                    value={search}

                    onChange={(e) =>

                        setSearch(

                            e.target.value

                        )

                    }

                />

            </div>

            {/* Loading */}

            {

                loading && (

                    <div className="loading">

                        Loading...

                    </div>

                )

            }

            {/* Conversation List */}

            <div className="conversation-list">

                {

                    conversations.length === 0 && (

                        <div className="empty-chat">

                            No Conversations

                        </div>

                    )

                }

                {

                    conversations.map(

                        (chat) => (

                            <div

                                key={chat.phoneNumber}

                                className={

                                    selectedConversation?.phoneNumber ===

                                        chat.phoneNumber

                                        ?

                                        "conversation active"

                                        :

                                        "conversation"

                                }

                                onClick={() =>

                                    onSelect(chat)

                                }

                            >

                                {/* Avatar */}

                                <div className="avatar">

                                    <User

                                        size={24}

                                    />

                                </div>

                                {/* Info */}

                                <div className="conversation-info">

                                    <div className="conversation-top">

                                        <h4>

                                            {

                                                chat.name ||

                                                chat.phoneNumber

                                            }

                                        </h4>

                                        <span>

                                            {

                                                chat.lastMessageTime ?

                                                    new Date(

                                                        chat.lastMessageTime

                                                    ).toLocaleTimeString(

                                                        [],

                                                        {

                                                            hour: "2-digit",

                                                            minute: "2-digit"

                                                        }

                                                    )

                                                    :

                                                    ""

                                            }

                                        </span>

                                    </div>

                                    <p>

                                        {

                                            chat.lastMessage ||

                                            "No Messages"

                                        }

                                    </p>

                                </div>

                            </div>

                        )

                    )

                }

            </div>

        </div>

    );

}
